/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import NoteHtml from 'DesignSystem/NoteHtml/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Note/Content/Display/Content",
  onClick
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let noteValueData = fromData.useDataFormat({ viewPath,
context: 'note',
format: fromHelpers.isEditable,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let noteNoteValueData = fromData.useDataValue({ viewPath,
context: 'note',
path: 'note',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<button
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 onClick={noteValueData ? () => setFlowTo(fromFlow.normalizePath(viewPath, '../../Edit/Content')) : onClick}
 style={{'--pt-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--c-5-Z1Yf8zk': noteValueData ? "pointer" : "auto"}}
 className={`views-block ${styles.Horizontal}`}
>
<NoteHtml
  viewPath={`${viewPath}/NoteHtml`}
 color={dtColorsNeutral900}
 data="note.note"
 html={noteNoteValueData}
/>
</button>
{children}
</React.Fragment>)
}